import React from "react";
import { Link } from 'react-router-dom';
import shape2 from '../../images/shapes/shape_section_divider_1.svg';
// import Bg from '../../images/about/whitepaper_image_bg.webp';
// import Bg from '../../images/bg.jpg'
import wImg from '../../images/robot-right-1.png';
import check from '../../icons/icon_check.svg';

const WhitepaperSection = () => {

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  }

  return (
    <section
      id="id_ico_whitepaper_section"
      className="ico_whitepaper_section section_space pb-0 section_decoration section_shadow_top"
    >
      <div className="decoration_item shape_divider_1">
        <img
          src={shape2}
          alt="Shape Divider"
        />
      </div>
      <div className="container">
        <div
          className="ico_heading_block text-center mt-lg-4"
          data-aos="fade-up"
          data-aos-duration="800"
        >
          <h2 className="heading_text mb-0">Developer Hub</h2>
        </div>

        <div
          className="whitepaper_content"
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-delay="100"
        >
          <div className="row m-0 align-items-center">
            <div className="col-lg-6 p-0">
              <div
                className="whitepaper_image_wrap"
                // style={{
                //   backgroundImage: {Bg},
                // }}
              >
                <div className="image_block">
                  <img
                    src={wImg}
                    alt="Developer Hub"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6 p-0">
              <div className="whitepaper_info_wrap">
                <div className="info_wrap_1">
                  <h3 className="heading_text">Launch your AI agent on Nimanode</h3>
                  <p>
                    Interested in  launching your AI Agent Idea with us
                  </p>
                  <ul className="partners_group unordered_list">
                    <li>
                      <Link className="ico_creative_btn" to="/" onClick={ClickHandler}>
                        <span className="btn_wrapper">
                          <span className="btn_label">Apply Now</span>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="info_wrap_2">
                  <h3 className="heading_text">Deploy AI solutions on the Marketplace</h3>
                  <p>
                    Intrested in Listing your AI agent on our Marketplace?
                  </p>
                  <div className="row">
                    <div className="col-md-6">
                      <ul className="iconlist_block unordered_list_block">
                        <li>
                          <span className="iconlist_icon">
                            <img
                              src={check}
                              alt="Icon Check"
                            />
                          </span>
                          <span className="iconlist_label">Coming Soon.</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhitepaperSection;
